<div class="patient-card" [pTooltip]="'general.dashboard-map.infoPanel.labels.patientInfo' | translate" tooltipPosition="top">
    <div class="patient-title">
        <i class="fa-solid fa-hospital-user title-icon"></i>
        <span style="font-weight: bold;">{{patient.firstName}} {{patient.lastName}}</span>
    </div>
    <div class="patient-info">
        <span *ngIf="patient.age">{{patient.age + ' ' + ('general.dashboard-map.infoPanel.labels.yearsOld' | translate)}}</span>
        <i *ngIf="patient.gender" class="fa" [class.fa-mars]="patient.gender === 'Male'" [class.fa-venus]="patient.gender === 'Female'"></i>
    </div>
</div>